import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import PagebuilderModal from '../../components/blocks/modal/index';

const SiteModal = () => {
  const { strapiSite } = useStaticQuery(graphql`
    query StrapiSiteSiteModalQuery {
      strapiSite {
        modal {
          ...PagebuilderMODAL
        }
      }
    }
  `);

  if (!strapiSite.modal) {
    return null;
  }

  return (
    <PagebuilderModal {...strapiSite.modal} />
  );
};

export default SiteModal;
